import { createAction } from 'redux-actions-helpers'
import { CourseType, ProgressType } from './types'

export const fetchCoursePage = createAction(
  '@@course-page/FETCH_COURSE_PAGE',
  (id: string): any => ({ id })
)

export const fetchCoursePageSuccess = createAction(
  '@@course-page/FETCH_COURSE_PAGE_SUCCESS',
  (result: CourseType): any => ({ result })
)

export const fetchCoursePageFailure = createAction(
  '@@course-page/FETCH_COURSE_PAGE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourseUserState = createAction(
  '@@course-page/FETCH_COURSE_USER_STATE',
  (id: string): any => ({ id })
)

export const fetchCourseUserStateSuccess = createAction(
  '@@course-page/FETCH_COURSE_USER_STATE_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchCourseUserStateFailure = createAction(
  '@@course-page/FETCH_COURSE_USER_STATE_FAILURE',
  (error: string): any => ({ error })
)

export const joinCourse = createAction(
  '@@course-page/JOIN_COURSE',
  (id: string): any => ({ id })
)

export const joinCourseSuccess = createAction(
  '@@course-page/JOIN_COURSE_SUCCESS'
)

export const joinCourseFailure = createAction(
  '@@course-page/JOIN_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const joinModule = createAction(
  '@@course-page/JOIN_MODULE',
  (id: string, mid: string, sid: string): any => ({ id, mid, sid })
)

export const joinModuleSuccess = createAction(
  '@@course-page/JOIN_MODULE_SUCCESS'
)

export const joinModuleFailure = createAction(
  '@@course-page/JOIN_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const repayCourse = createAction(
  '@@course-page/REPAY_COURSE',
  (id: string): any => ({ id })
)

export const repayCourseSuccess = createAction(
  '@@course-page/REPAY_COURSE_SUCCESS'
)

export const repayCourseFailure = createAction(
  '@@course-page/REPAY_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@course-page/DESTROY')
